import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Back — return arrow. */
export function BackIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M19 12H5M10.5 6.5 5 12l5.5 5.5" />
    </PortalIcon>
  );
}
